import { render, staticRenderFns } from "./CircuitBreakerAging.vue?vue&type=template&id=36b193d7&scoped=true&"
import script from "./CircuitBreakerAging.vue?vue&type=script&lang=js&"
export * from "./CircuitBreakerAging.vue?vue&type=script&lang=js&"
import style0 from "./CircuitBreakerAging.vue?vue&type=style&index=0&id=36b193d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b193d7",
  null
  
)

export default component.exports